import React from 'react';
import Icon from '../AppIcon';

const StarRating = ({ 
  rating = 0, 
  maxStars = 5, 
  size = 16, 
  showCount = false, 
  reviewCount = null,
  className = "",
  interactive = false,
  onRatingChange = null
}) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = maxStars - Math.ceil(rating);

  // Create full stars
  for (let i = 0; i < fullStars; i++) {
    stars?.push(
      <Icon 
        key={`full-${i}`} 
        name="Star" 
        size={size} 
        className={`text-yellow-500 ${interactive ? 'cursor-pointer hover:text-yellow-600' : ''}`}
        onClick={interactive ? () => onRatingChange?.(i + 1) : undefined}
      />
    );
  }

  // Add half star if needed
  if (hasHalfStar) {
    stars?.push(
      <div key="half" className={`relative inline-block ${interactive ? 'cursor-pointer' : ''}`}>
        <Icon 
          name="Star" 
          size={size} 
          className="text-gray-300"
        />
        <div className="absolute inset-0 overflow-hidden" style={{ width: '50%' }}>
          <Icon 
            name="Star" 
            size={size} 
            className="text-yellow-500"
          />
        </div>
      </div>
    );
  }

  // Create empty stars
  for (let i = 0; i < emptyStars; i++) {
    stars?.push(
      <Icon 
        key={`empty-${i}`} 
        name="Star" 
        size={size} 
        className={`text-gray-300 ${interactive ? 'cursor-pointer hover:text-yellow-400' : ''}`}
        onClick={interactive ? () => onRatingChange?.(fullStars + (hasHalfStar ? 1 : 0) + i + 1) : undefined}
      />
    );
  }

  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      <div className="flex items-center space-x-0.5">
        {stars}
      </div>
      {rating > 0 && (
        <span className="text-sm font-medium text-foreground ml-2">
          {rating?.toFixed(1)}
        </span>
      )}
      {showCount && reviewCount !== null && reviewCount > 0 && (
        <span className="text-sm text-muted-foreground ml-1">
          ({reviewCount} review{reviewCount !== 1 ? 's' : ''})
        </span>
      )}
    </div>
  );
};

export default StarRating;